class ValidateForm {
    constructor(formElement, options) {
        if (formElement.dataset.skipValidate || formElement.dataset.validateForm || !formElement.querySelector('[data-validate]')) return;

        this.form = formElement;
        this.options = this._defineOptions(options);
        this.submitButton = this.form.querySelector('.js-form-submit') || this.form.querySelector('[type="submit"]');

        this.form.validate = this;

        this._init();
    }

    _init = () => {
        this.form.setAttribute('novalidate', '');
        this.submitButton.setAttribute('disabled', '');
        //this.checkValidForm();

        this.checkValidationOnExcitation();

        this.form.addEventListener('focusin', this._onFocusHandler);
        this.form.addEventListener('focusout', this._onBlurHandler);
        this.form.addEventListener('change', this._onChangeHandler);
        this.form.addEventListener('input', this._onInputHandler);

        this.form.addEventListener('pickerselect', this._onPickerHandler);
        this.form.addEventListener('input', this._onPickerHandler);

        this.form.setAttribute('data-validate-form', '');
    }

    checkValidationOnExcitation = () => {
        const inputs = this.form.querySelectorAll('[data-validate]');
        const filteredByValue = Array.from(inputs).filter(input => input.value.trim());

        if (!filteredByValue.length) return;

        filteredByValue.forEach(input => {
            const validateSettings = this.getInputValidateSettings(input);

            const isError = this.validate(input, validateSettings);

            if (isError) {
                input.classList.remove('valid');
            } else {
                let wrapper = input.closest(`.${this.options.elementWrapperClass}`);
                if(wrapper){
                    wrapper.classList.remove(`${this.options.elementWrapperErrorClass}`);
                }
                input.classList.add('valid');
            }
        })

        this.checkValidForm();
    }

    _onPickerHandler = (e) => {
        const target = e.target.closest('[data-validate].js-datepicker');

        if (!target) return;

        if (target.value.includes('_') && this.getInputValidateSettings(target).includes('required')) {
            this.setError(target, 'required');
            target.classList.remove('valid');
            this.checkValidForm();
            return;
        }

        this.checkValidDate(target);
    }

    checkValidDate = (target) =>{
        const value = target.value;
        const date = value.split('.');

        const dateSelect = Date.parse(`${date[2]}-${date[1]}-${date[0]}`);
        const reverse = (typeof target.dataset.reverse != 'undefined');

        if (value.length && (!dateSelect || ((reverse && Date.now() - dateSelect > 0) || (!reverse && Date.now() - dateSelect <= 0)))) {
            this.setError(target, 'date');
            target.classList.remove('valid');
        } else {
            const wrapper = target.closest(`.${this.options.elementWrapperClass}`);

            wrapper.classList.remove(`${this.options.elementWrapperErrorClass}`);
            target.classList.add('valid');
        }

        this.checkValidForm();
    }

    _onInputHandler = (e) => {
        const target = e.target.closest('[data-validate]');

        if (!target) return;

        const validateSettings = this.getInputValidateSettings(target);

        const error = this.validate(target, validateSettings);

        if (error) {
            target.classList.remove('valid');
        } else {
            target.classList.add('valid');
        }

        this.checkValidForm();
    }

    _onChangeHandler = (e) => {
        const target = e.target.closest('[data-validate]');

        if (!target) return;

        const validateSettings = this.getInputValidateSettings(target);

        const isError = this.validate(target, validateSettings);

        if (isError) {
            target.classList.remove('valid');
        } else {
            target.classList.add('valid');
        }

        this.checkValidForm();
    }

    _onFocusHandler = (e) => {
        const target = e.target.closest('[data-validate]');

        if (!target) return;

        const wrapper = target.closest(`.${this.options.elementWrapperClass}`);

        wrapper.classList.remove(`${this.options.elementWrapperErrorClass}`);
    }

    _onBlurHandler = (e) => {
        const target = e.target.closest('[data-validate]');

        if (!target) return;

        const validateSettings = this.getInputValidateSettings(target);

        if (validateSettings.includes('date')) {
            this.checkValidDate(target);
            return;
        }

        const error = this.validate(target, validateSettings);

        if (error) {
            target.classList.remove('valid');
            this.setError(target, error)
        } else {
            target.classList.add('valid');
        }

        this.checkValidForm();
    }

    markNotValidInputs = () => {
        const validatingInputs = this.form.querySelectorAll(`[data-validate]`);
        const filteredInputs = Array.from(validatingInputs).filter(input => {
            return (
                this.getInputValidateSettings(input).includes('required') ||
                input.files?.length ||
                (input.classList.contains('js-datepicker') && input.value)
            )
        });

        const notValidInputs = filteredInputs.filter(input => !input.classList.contains('valid'));

        notValidInputs.forEach(input => {
            const validateSettings = this.getInputValidateSettings(input);

            if (validateSettings.includes('date')) {
                this.checkValidDate(input);
                return;
            }

            const error = this.validate(input, validateSettings);

            if (error) {
                input.classList.remove('valid');
                this.setError(input, error)
            } else {
                input.classList.add('valid');
            }
        });
    }

    checkValidForm = () => {
        const validatingInputs = this.form.querySelectorAll(`[data-validate]`);
        const filteredInputs = Array.from(validatingInputs).filter(input => {
            return (
                this.getInputValidateSettings(input).includes('required') ||
                input.files?.length ||
                (input.classList.contains('js-datepicker') && input.value)
            )
        });

        const validInputs = filteredInputs.filter(input => input.classList.contains('valid'));

        if (filteredInputs.length === validInputs.length) {
            this.setSubmitDisabled(false)
        } else {
            this.setSubmitDisabled(true)
        }
    }

    setSubmitDisabled = (isDisabled) => {
        if (isDisabled) {
            this.submitButton.setAttribute('disabled', '');
        } else {
            this.submitButton.removeAttribute('disabled');
        }
    }

    getInputValidateSettings = (input) => {
        return input.dataset.validate.split('|');
    }

    setError = (input, rule) => {
        const wrapper = input.closest(`.${this.options.elementWrapperClass}`);

        let elementError = wrapper.querySelector(`${this.options.errorElement}.${this.options.errorClass}`);

        if (!elementError) {
            elementError = document.createElement(`${this.options.errorElement}`);
            elementError.classList.add(`${this.options.errorClass}`)
            wrapper.append(elementError);
        }

        wrapper.classList.add(`${this.options.elementWrapperErrorClass}`);

        switch (rule) {
            case 'required':
                elementError.textContent = this.options.messages.required;
                break;
            case 'tel':
                elementError.textContent = this.options.messages.tel;
                break;
            case 'email':
                elementError.textContent = this.options.messages.email;
                break;
            case 'name':
                elementError.textContent = this.options.messages.name;
                break;
            case 'date':
                elementError.textContent = this.options.messages.date;
                break;
            case 'notZero':
                elementError.textContent = this.options.messages.notZero;
                break;
        }
    }

    validate = (input, rules) => {
        const value = input.value.trim();

        let error = false;

        if (
            !rules.includes('date') &&
            (
                (rules.includes('required') && !value.length) ||
                (rules.includes('required') && (['radio', 'checkbox'].includes(input.type)) && !input.checked)
            )
        ) {
            error = 'required';

            return error;
        }

        rules.forEach(rule => {
            switch (rule) {
                case 'tel':
                    if (value.length !== 18 || value.includes('_')) {
                        error = 'tel';
                    }
                    break;
                case 'email':
                    if (!(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu.test(value))) {
                        error = 'email';
                    }
                    break;
                case 'name':
                    if (value.length < 2 || value.length > 30 || !(/^[a-zA-Zа-яёЁА-Я'][a-zA-Zа-яёЁА-Я-' ]+[a-zA-Zа-яёЁА-Я']?$/u.test(value))) {
                        error = 'name';
                    }
                    break;
                case 'notZero':
                    if (parseInt(value, 10) === 0) {
                        error = 'notZero';
                    }
                    break;
            }
        })

        return error;
    }

    _defineOptions = (options) => {
        const defaultOptions = {
            ignoreClass: 'ignore',
            elementWrapperClass: "js-field",
            elementWrapperErrorClass: "field__error",
            errorElement: "span",
            errorClass: "error",
            successClass: "valid",
            messages: {
                required: "Это обязательное поле",
                tel: "Неверный ввод телефона",
                email: "Неверный ввод почты",
                name: "Неверный ввод имени",
                date: "Неверный ввод даты",
                notZero: "Неверный ввод (ноль)",
            }
        }

        switch (window.lang) {
            case 'en': {
                defaultOptions.messages = {
                    required: "This is a required field",
                    tel: "Invalid phone input",
                    email: "Invalid mail entry",
                    name: "Invalid name entry",
                    date: "Invalid date entry",
                    notZero: "Invalid input (zero)",
                }
            }
        }

        return {
            ...defaultOptions,
            options
        }
    }
}
